// extracted by mini-css-extract-plugin
export var actionButton = "_fu-0";
export var attachmentLine = "_fu-1";
export var fileInput = "_fu-2";
export var fileUploadWrapper = "_fu-4";
export var footer = "_fu-3";
export var modalContent = "_fu-5";
export var paperclip = "_fu-6";
export var quillEditor = "_fu-7";